import { ConfigurationData } from './state';
export type GlobalConfigurationAction = { type: 'SET_CONFIGURATION'; payload: Array<ConfigurationData> };

export const setConfigurationAction = (payload: Array<ConfigurationData>): GlobalConfigurationAction => ({
  type: 'SET_CONFIGURATION',
  payload,
});
